var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.313 3.5 3.5 7.313 3.5 12C3.5 16.687 7.313 20.5 12 20.5C16.687 20.5 20.5 16.687 20.5 12C20.5 7.313 16.687 3.5 12 3.5ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5585 16.2208C10.3665 16.2208 10.1735 16.1478 10.0275 15.9998C9.73546 15.7058 9.73646 15.2318 10.0295 14.9398L12.9815 11.9998L10.0295 9.0608C9.73646 8.7688 9.73546 8.2938 10.0275 7.9998C10.3195 7.7048 10.7935 7.7068 11.0875 7.9978L14.5735 11.4688C14.7145 11.6098 14.7935 11.8008 14.7935 11.9998C14.7935 12.1998 14.7145 12.3908 14.5735 12.5318L11.0875 16.0018C10.9415 16.1478 10.7495 16.2208 10.5585 16.2208Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightC);
export default __webpack_public_path__ + "static/media/ArrowRightC.9ae6eaa31c50b4ee7cfee7d722dea7f2.svg";
export { ForwardRef as ReactComponent };